export default [
  'B2B',
  'B2C',
  'E-Commerce',
  'Enterprise',
  'ISP',
  'Marketplace',
  'Mobile',
  'SAAS',
  '3D Printing',
  'Accounting',
  'Aerospace & Defense',
  'Agriculture',
  'Airlines',
  'Alternative Medicine',
  'Animation',
  'Apparel & Fashion',
  'Apparel & Footwear',
  'Architecture',
  'Arts',
  'Arts & Crafts',
  'Asset Management',
  'Audio',
  'Automation',
  'Automotive',
  'Banking & Mortgages',
  'Beverages',
  'Biotechnology',
  'Broadband',
  'Broadcasting',
  'Building Materials',
  'Business Supplies',
  'Chemicals',
  'Civil Engineering',
  'Cloud Services',
  'Communications',
  'Computer Hardware',
  'Computer Networking',
  'Construction',
  'Consulting & Professional Services',
  'Consumer Discretionary',
  'Consumer Electronics',
  'Consumer Goods',
  'Consumer Staples',
  'Corporate & Business',
  'Cosmetics',
  'Design',
  'E-Commerce & Marketplaces',
  'E-Learning',
  'Education',
  'Electrical',
  'Energy',
  'Entertainment & Recreation',
  'Eyewear',
  'Facilities',
  'Family Services',
  'Finance',
  'Financial Services',
  'Fine Art',
  'Fishery',
  'Food',
  'Food Production',
  'Food, Beverage & Tobacco',
  'Fundraising',
  'Gambling & Casinos',
  'Graphic Design',
  'Ground Transportation',
  'Health & Wellness',
  'Health Care',
  'Higher Education',
  'Home & Furniture',
  'Home Improvement',
  'Human Resources',
  'Import & Export',
  'Industrials & Manufacturing',
  'Information Technology & Services',
  'Insurance',
  'International Relations',
  'International Trade',
  'Internet',
  'Investment',
  'Investment Banking',
  'Investment Management',
  'Jewelry, Watches & Luxury Goods',
  'Legal Services',
  'Libraries',
  'Machinery',
  'Maritime',
  'Market Research',
  'Marketing & Advertising',
  'Mechanical Engineering',
  'Media',
  'Medicine',
  'Military',
  'Mining & Metals',
  'Mobile',
  'Movies & TV',
  'Museums',
  'Music',
  'Nanotechnology',
  'Oil & Gas',
  'Outsourcing',
  'Packaging & Containers',
  'Paper Goods',
  'Payments',
  'Pharmaceuticals',
  'Pharmacy',
  'Photography',
  'Plastics',
  'Plumbing',
  'Pornography',
  'Primary & Secondary Education',
  'Printing',
  'Public Relations',
  'Publishing',
  'Ranching',
  'Real Estate',
  'Renewable Energy',
  'Renewables & Environment',
  'Research',
  'Restaurants',
  'Retail',
  'Security',
  'Services',
  'Shipbuilding',
  'Shipping & Logistics',
  'Sporting Goods',
  'Sports & Fitness',
  'Supermarkets',
  'Talent Agencies',
  'Technology',
  'Telecommunications',
  'Textiles',
  'Tobacco',
  'Tools',
  'Translation',
  'Transportation',
  'Travel & Leisure',
  'Utilities',
  'Venture Capital',
  'Veterinary',
  'Video Games',
  'Wholesale',
  'Wireless',
]



// WEBPACK FOOTER //
// ./src/scripts/constants/ClearbitTags.js